export default function DonutChart({ percent }) {
  return (
    <div className="relative mx-auto flex h-[110px] w-[110px] items-center justify-center sm:h-[140px] sm:w-[140px]">
      <div
        className="absolute inset-0 rounded-full"
        style={{
          background: `conic-gradient(#8A6819 0 ${percent}%, #E5DED3 ${percent}% 100%)`,
        }}
      />
      <div className="relative flex h-[68px] w-[68px] flex-col items-center justify-center rounded-full bg-white sm:h-[88px] sm:w-[88px]">
        <strong className="text-xl font-bold text-[#1A1A1A] sm:text-2xl">{percent}%</strong>
        <span className="text-[10px] font-bold text-[#5A5147] sm:text-xs">Particular</span>
      </div>
    </div>
  )
}
